"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.faq.question1': '我们的AI助手如何帮助您',
    'onboarding.faq.answer1.intro': '我们的AI助手是支持关键业务功能的多功能工具。它可以充当以下角色：',
    'onboarding.faq.answer1.role1': '销售专员：自动化沟通、潜在客户资格审查、销售流程支持。',
    'onboarding.faq.answer1.role2': '程序员/开发人员：根据规范生成新代码，快速原型制作和优化现有解决方案。',
    'onboarding.faq.answer1.role3': '法律/分析支持：使用自己广泛的知识库快速准备分析、法律文本草稿和文档。',
    'onboarding.faq.answer1.role4': '内容创作者：快速准备文本草稿、图形和通信材料，保持公司风格的一致性。',
    'onboarding.faq.question2': '完整的入职流程是什么样的？',
    'onboarding.faq.answer2.intro': '入职流程的设计以最大的简单性和效率为目标。它只包括几个关键步骤：',
    'onboarding.faq.answer2.step1': '数据输入：提供必要的上下文和操作数据，这些数据构成助手运行的基础。',
    'onboarding.faq.answer2.step2': '知识库定义：用公司知识库、文档和程序来充实助手。',
    'onboarding.faq.answer2.step3': '输出参数设置：配置首选的沟通风格、语调、格式和生成数据的结构（例如文本、代码、图形）。',
    'onboarding.faq.question3': '入职的主要目标是什么？',
    'onboarding.faq.answer3.intro': '实施流程（入职）的主要目标是确保AI助手的即时操作准备。我们专注于确保：',
    'onboarding.faq.answer3.goal1': '助手完全理解您行业的特殊性和内部程序。',
    'onboarding.faq.answer3.goal2': '它生成的内容、代码和分析与您的品牌标准和技术要求保持一致。',
    'onboarding.faq.answer3.goal3': '最大化从实施到实现完全生产力和投资回报(ROI)的时间。',
    'onboarding.faq.question4': '我需要验证AI生成的内容吗？',
    'onboarding.faq.answer4.intro': '我们建议，特别是在初始阶段，AI助手生成的所有关键内容和决策都应接受您团队的实质性验证。尽管我们的模型具有高精度特点，但人工监督对于以下方面至关重要：',
    'onboarding.faq.answer4.reason1': '保持与内部政策和当前法律法规的合规性。',
    'onboarding.faq.answer4.reason2': '确保复杂、非标准场景中的上下文准确性。',
    'onboarding.faq.answer4.conclusion': '这是标准的良好操作实践，可最大化风险并确保最高质量的结果。',
};
